module.exports = __webpack_public_path__ + "files/58c6848a9cdbc0ad6f0ceca210b6f418.svg";